import type { FiltroPendencia, StatusPendencia } from '@/features/secretaria-arbitral/types';
import type { GrupoDestinatarioPendencia } from '@/features/secretaria-arbitral/types/detalheExtras';

// TODO(#794): este mapa existe em 4 lugares (aqui, `arbitro/components/detalhe/PendenciasPanel`,
// `arbitral-detalhes/utils/arbitralDetailUtils` e o editor de fluxos). Promover para
// `shared/` é refactor cross-feature e vai em PR próprio.
const TIPO_LABEL: Record<string, string> = {
  CONCLUSO: 'Concluso',
  MANIFESTACAO: 'Manifestação',
  DOCUMENTACAO: 'Documentação',
  PAGAMENTO: 'Pagamento',
  ESCLARECIMENTO: 'Esclarecimento',
  ASSINATURA: 'Assinatura',
  INFORMACAO: 'Informação',
  CORRECAO_DADO: 'Correção de dado',
  HABILITACAO_ADVOGADO: 'Habilitação de advogado',
  OFICIO_REQUISITORIO: 'Ofício requisitório',
  REGULARIZACAO_TRIAGEM: 'Regularização da triagem',
  TERMO_IMPARCIALIDADE: 'Termo de imparcialidade',
  IMPUGNACAO_ARBITRO: 'Impugnação de árbitro',
  PRAZO_IMPUGNACAO_ARBITRO: 'Prazo para impugnar o árbitro',
  KYC: 'Verificação KYC',
  AUTORIZACAO_ENVIO_AR: 'Autorização de envio de AR',
  OUTROS: 'Outros',
  CONCLUSO_RESPONDIDO: 'Resposta do árbitro ao concluso',
};

export const rotuloTipoPendencia = (tipo: string): string =>
  TIPO_LABEL[tipo] ?? tipo.charAt(0) + tipo.slice(1).toLowerCase().replaceAll('_', ' ');

/**
 * Tipos que a Secretaria pode criar pela aba. Allowlist espelhada de
 * `TIPOS_PENDENCIA_SECRETARIA` do backend: tipo com efeito colateral na resolução (concluso,
 * habilitação de advogado, os de flow) e `REGULARIZACAO_TRIAGEM` (exclusivo de automação)
 * ficam de fora — criados à mão nasceriam sem os vínculos que o fluxo preenche.
 */
export const TIPOS_PENDENCIA_SECRETARIA: readonly string[] = [
  'ESCLARECIMENTO',
  'DOCUMENTACAO',
  'PAGAMENTO',
  'MANIFESTACAO',
  'INFORMACAO',
  'CORRECAO_DADO',
  'ASSINATURA',
  'OFICIO_REQUISITORIO',
  'OUTROS',
];

export const TIPO_PENDENCIA_PADRAO = 'ESCLARECIMENTO';

export const STATUS_PENDENCIA_LABEL: Record<StatusPendencia, string> = {
  ABERTA: 'Aberta',
  EXPIRADA: 'Expirada',
  AGUARDANDO_VALIDACAO: 'Aguardando validação',
  REJEITADA: 'Rejeitada',
  RESOLVIDA: 'Resolvida',
  ENCERRADA_PELA_SENTENCA: 'Encerrada pela sentença',
};

export const STATUS_PENDENCIA_VARIANT: Record<
  StatusPendencia,
  'success' | 'error' | 'neutral' | 'warning'
> = {
  ABERTA: 'warning',
  EXPIRADA: 'error',
  AGUARDANDO_VALIDACAO: 'warning',
  REJEITADA: 'error',
  RESOLVIDA: 'success',
  ENCERRADA_PELA_SENTENCA: 'neutral',
};

export const FILTRO_PENDENCIA_PADRAO: FiltroPendencia = 'ativas';

export const FILTROS_PENDENCIA: { value: FiltroPendencia; label: string }[] = [
  { value: 'ativas', label: 'Ativas' },
  { value: 'finalizadas', label: 'Finalizadas' },
  { value: 'todas', label: 'Todas' },
];

export const GRUPO_DESTINATARIO_LABEL: Record<GrupoDestinatarioPendencia, string> = {
  REQUERENTE: 'Requerente',
  REQUERIDO: 'Requerido',
  ARBITRO: 'Árbitro',
  TODAS_AS_PARTES: 'Todas as partes',
};
